import {
  MockMap,
} from '@ama-sdk/core';
import {
  ErrorMessage,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  BoardingPassDataRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  createMockData,
  createMockDataWithResponse,
  MockBoardingPassResult,
  MockJourney,
} from '@dapi/sdk/spec';
import {
  assignSeatToJourneyElements,
  retrieveSeatMapsJourneyDriven,
} from '../common/seatmap';
import {
  acceptedChoosenJourney,
  chosenJourney,
  journeyElementIds,
  journeys,
  validRegulatoryChoosenJourney,
} from './journey-logic';
import {
  addRegulatoryDetails,
  getRegulatoryDetails,
} from './regulatory-logic';

const bp: MockBoardingPassResult[] = combineBoardingPassResults([{
  boardingPassData: BoardingPassDataRepository.TSA
}], {
  journeyElementIds
}).items;

const retrieveJourney: MockJourney[] = Array.from<MockJourney>({
  length: addRegulatoryDetails.length - 1
}).fill(chosenJourney).concat(validRegulatoryChoosenJourney, acceptedChoosenJourney);

const noUnpaid: ErrorMessage[] = [{
  code: '10000',
  title: 'No unpaid service',
  type: 'error',
  id: '10000'
}];

const seatmap = retrieveSeatMapsJourneyDriven(journeys[0], journeys[0].travelers.map((t) => t.id).filter((id): id is string => !!id));

export const demo: MockMap = {
  addRegulatoryDetails: addRegulatoryDetails.map((reg) => createMockData({
    ...reg,
    travelerId: 'JOURNEY-TRAVELER-1-MOCK'
  })),
  assignSeatToJourneyElement: assignSeatToJourneyElements(journeys[0], seatmap).map((seat) => createMockDataWithResponse(seat, 201)),
  generateBoardingPasses: [createMockDataWithResponse(bp, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, noUnpaid), createMockDataWithResponse(undefined, 404, noUnpaid)],
  getRegulatoryDetails: [createMockData({
    ...getRegulatoryDetails,
    travelerId: 'JOURNEY-TRAVELER-1-MOCK'
  })],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourney: retrieveJourney.map((j) => createMockData(j)),
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [createMockDataWithResponse(journeys, 201)],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
